import { Controller } from '@hotwired/stimulus'

// Marketing homepage — fills the VIN input when a sample-VIN pill is clicked.
//
// Used inside the static idle-state markup of the AI VIN demo widget. Once
// the Vue island (VinDemoWidget) takes over, this controller's element is
// replaced and the controller silently disconnects.
export default class extends Controller {
  static targets = ['input']

  fill(event) {
    event.preventDefault()
    const button = event.currentTarget
    const vin = button.getAttribute('data-vin')
    if (!vin || !this.hasInputTarget) return
    this.inputTarget.value = vin
    this.inputTarget.focus()
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }
}
